import * as Sentry from "@sentry/react";

export function initSentry() {
  if (import.meta.env.VITE_SENTRY_DSN == null) {
    return;
  }
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT == null) {
    // This will prevent the configuration of sentry as a whole. This function will
    // be turned into a no-op as a consequence of vite not finding the environment variable.
    throw new Error("missing sentry environment");
  }
  const dsn = import.meta.env.VITE_SENTRY_DSN.toString();
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT.toString();
  Sentry.init({
    dsn,
    environment,
  });
}
